import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { CUSTOM_FILTERS } from "@/config/list";
import type { ListFilters } from "@/types/list";

type AlarmTypeFilterValue = Dryp.AlarmType | "all";

interface AlarmTypeFilterProps {
	filter: ListFilters;
}

const OPTIONS: { value: AlarmTypeFilterValue; label: string }[] = [
	{ value: "all", label: "All" },
	{ value: "device_health", label: "Device" },
	{ value: "measurement", label: "Hydraulic" },
];

const readSelected = (raw: unknown): Dryp.AlarmType | undefined => {
	if (Array.isArray(raw)) return raw[0] as Dryp.AlarmType | undefined;
	if (typeof raw === "string") return raw as Dryp.AlarmType;
	return undefined;
};

export const AlarmTypeFilter = ({ filter }: AlarmTypeFilterProps) => {
	const selected = readSelected(filter.getFilter(CUSTOM_FILTERS.alarmType));
	const value: AlarmTypeFilterValue = selected ?? "all";
	const selectedLabel = OPTIONS.find(option => option.value === value)?.label ?? "All";

	const handleSelect = (next: AlarmTypeFilterValue) => {
		if (next === "all") {
			filter.clearFilter(CUSTOM_FILTERS.alarmType);
		} else {
			filter.setFilter(CUSTOM_FILTERS.alarmType, [next]);
		}
	};

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Type</span>

				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" className="justify-start gap-2">
							<span className={value === "all" ? "font-semibold text-muted-foreground" : "font-semibold"}>
								{selectedLabel}
							</span>
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>

					<DropdownMenuContent align="start">
						{OPTIONS.map(option => (
							<DropdownMenuItem
								key={option.value}
								onSelect={() => handleSelect(option.value)}
								className={value === option.value ? "font-semibold bg-muted" : ""}
							>
								{option.label}
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
